var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9702 8.92236V34.2913C26.9702 35.2353 26.2052 36 25.2616 36H2.65105C1.70746 36 0.942383 35.2353 0.942383 34.2913V1.70901C0.942383 0.765073 1.70746 0 2.65105 0H17.426L26.9702 8.92236Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9702 8.92236V9.18646H18.4674C17.8183 9.18646 17.2919 8.66 17.2919 8.01056V0H17.426L26.9702 8.92236Z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1587 18.5474H5.75433V19.9615H22.1587V18.5474Z",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1586 21.8059H5.75427V23.2201H22.1586V21.8059Z",
    fill: "#E6E7E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1586 25.0647H5.75427V26.4789H22.1586V25.0647Z",
    fill: "#E6E7E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1586 28.3235H5.75427V29.7376H22.1586V28.3235Z",
    fill: "#E6E7E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1586 31.582H5.75427V32.9962H22.1586V31.582Z",
    fill: "#E6E7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMessage);
export default __webpack_public_path__ + "static/media/file_message.be584504e290d1804d0c59c889398cc0.svg";
export { ForwardRef as ReactComponent };